<template>
    <div>
        <h1>
            {{ status == 1 ? $t('mojefirmy.text_16') : $t('mojefirmy.text_17') }}
        </h1>
        <div class="form">
            <h3>Základné údaje</h3>
            <div class="one">
                <div class="form-floating" :style="error.nazov ? 'border: 1px solid red;' : ''">
                    <input type="text" class="form-control" id="floatingInput" :placeholder="$t('mojefirmy.text_18')"
                        v-model="nazov" />
                    <label for="floatingInput">{{ $t('mojefirmy.text_18') }}</label>
                    <div class="info">
                        <div class="my_tooltip">
                            {{ $t('mojefirmy.text_19') }}
                        </div>
                        <div class="tooltip_hover info_icon">
                            <img src="/img/info_icon.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="one mt-3 ml-1">
                <div class="odkaz">
                    <div class="odkaz_text">
                        {{ $t('company.nazovslug_text_3') }}
                    </div>
                    <div class="bottom">
                        <div class="odkaz_web">
                            {{ appHost }}/ID_ponuky/
                        </div>
                        <input type="text" v-model="slug" :class="error.slug ? 'error' : ''">
                    </div>
                </div>
            </div>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingInput"
                        :placeholder="$t('company.webtel_text_1')" v-model="web" @input="webInput" />
                    <label for="floatingInput">{{ $t('company.webtel_text_1') }}</label>
                </div>
            </div>
            <div class="check mt-3">
                <div class="form-group">
                    <div class="d-flex align-items-center">
                        <input v-model="isDph" @click="isDph = !isDph" type="checkbox" class="toggle">
                        <label class="block mb-0 mt-1" @click="isDph = !isDph" style="cursor:pointer;">
                            {{ $t('company.webtel_text_3') }}
                        </label>
                        <div class="info">
                            <div class="my_tooltip">
                                {{ $t('company.webtel_text_4') }}
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/create_offer/info.svg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text" v-show="isDph">
                    <span>
                        {{ $t('company.webtel_text_5') }}
                    </span>
                    <input type="text" v-model="dph" @keypress="checkDph">
                    <span>
                        {{ $t('company.webtel_text_6') }}
                    </span>
                </div>
            </div>
        </div>
        <div class="form mt-4">
            <h3>{{ $t('company.firmakontakt_text_5') }}</h3>
            <h4>{{ $t('company.firmakontakt_text_6') }}</h4>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingInput"
                        :placeholder="$t('company.kontaktnaosoba_text_1')" v-model="osoba" />
                    <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_1') }}</label>
                </div>
            </div>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingInput"
                        :placeholder="$t('company.kontaktnaosoba_text_2')" v-model="osoba_tel" @keypress="onlyNumber" />
                    <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_2') }}</label>
                </div>
            </div>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingInput"
                        :placeholder="$t('company.kontaktnaosoba_text_3')" v-model="osoba_email" />
                    <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_3') }}</label>
                </div>
            </div>
        </div>
        <div class="form mt-4">
            <h3>{{ $t('mojefirmy.text_21') }}</h3>
            <h4>{{ $t('mojefirmy.text_22') }}</h4>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control nazov_spolocnosti" id="nazov_spolocnosti"
                        :placeholder="$t('mojefirmy.text_23')" v-model="nazov_spolocnosti" />
                    <label for="nazov_spolocnosti">{{ $t('mojefirmy.text_23') }}</label>
                </div>
            </div>
            <div class="two mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control ico" id="ico" :placeholder="$t('mojefirmy.text_24')"
                        @keypress="ico_checker" v-model="ico" />
                    <label for="ico">{{ $t('mojefirmy.text_24') }}</label>
                </div>
                <div class="form-floating">
                    <input type="text" class="form-control dic" id="dic" :placeholder="$t('mojefirmy.text_25')"
                        @keypress="dic_checker" v-model="dic" />
                    <label for="dic">{{ $t('mojefirmy.text_25') }}</label>
                </div>
            </div>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control ic_dph" id="ic_dph"
                        :placeholder="$t('mojefirmy.text_26')" v-model="ic_dph" />
                    <label for="ic_dph">{{ $t('mojefirmy.text_26') }}</label>
                </div>
            </div>
            <div class="one mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control ulica" id="ulica"
                        :placeholder="$t('mojefirmy.text_27')" v-model="ulica" />
                    <label for="ulica">{{ $t('mojefirmy.text_27') }}</label>
                </div>
            </div>
            <div class="three mt-3">
                <div class="form-floating left">
                    <input type="text" class="form-control psc" id="psc"
                        :placeholder="$t('mojefirmy.text_28')" @keypress="psc_checker" v-model="psc" />
                    <label for="psc">{{ $t('mojefirmy.text_28') }}</label>
                </div>
                <div class="form-floating right">
                    <input type="text" class="form-control mesto" id="mesto"
                        :placeholder="$t('mojefirmy.text_29')" v-model="mesto" />
                    <label for="mesto">{{ $t('mojefirmy.text_29') }}</label>
                </div>
            </div>
        </div>
        <div class="form mt-4">
            <h3>Logo a pečiatka/podpis</h3>
            <moja-firma-logo :preloadedfiles="logo" @getDataLogo="logo = $event" />
            <Signature :ploadsignature="signature" @data="signature = $event" />
        </div>
        <div class="form mt-4">
            <h3>{{ $t('company.firmakontakt_text_9') }}</h3>
            <h4>{{ $t('company.firmakontakt_text_10') }}</h4>
            <social-media :company="itemEdit" @data="getSocialMedia($event)" />
        </div>
        <div class="ulozit" @click="save">
            <span v-show="!saved">{{ $t('mojefirmy.text_30') }}</span>
            <div v-show="saved" class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
    import MojaFirmaLogo from "./MojaFirmaLogo.vue";
    import SocialMedia from "./SocialMedia.vue";
    import Signature from "./Signature.vue";
    export default {
        props: ["status", "user_id", "itemEdit"],
        components: {
            MojaFirmaLogo,
            SocialMedia,
            Signature
        },
        data() {
            return {
                appHost: window.location.host,
                error: {
                    nazov: false,
                    slug: false
                },
                id: null,
                nazov: "",
                web: "",
                osoba: "",
                osoba_tel: "",
                osoba_email: "",
                nazov_spolocnosti: "",
                ico: null,
                dic: null,
                ic_dph: null,
                ulica: "",
                psc: "",
                mesto: "",
                saved: false,
                logo: null,
                signature: null,
                fb: "",
                ig: "",
                yt: "",
                lin: "",
                slug: "",
                isDph: false,
                dph: "23",
            };
        },
        mounted() {
            if (this.status == 2) {
                this.id = this.itemEdit.id;
                this.nazov = this.itemEdit.nazov;
                this.osoba = this.itemEdit.osoba;
                this.osoba_tel = this.itemEdit.osoba_tel;
                this.osoba_email = this.itemEdit.osoba_email;
                this.web = this.itemEdit.web;
                this.nazov_spolocnosti = this.itemEdit.nazov_spolocnosti;
                this.ico = this.itemEdit.ico;
                this.dic = this.itemEdit.dic;
                this.ic_dph = this.itemEdit.ic_dph;
                this.ulica = this.itemEdit.ulica;
                this.psc = this.itemEdit.psc;
                this.mesto = this.itemEdit.mesto;
                this.logo = this.itemEdit.preloadedFiles;
                this.signature = this.itemEdit.preloadedFiles_signature;
                this.fb = this.itemEdit.fb;
                this.ig = this.itemEdit.ig;
                this.yt = this.itemEdit.yt;
                this.lin = this.itemEdit.lin;
                this.slug = this.itemEdit.slug;
                this.isDph = this.itemEdit.dph ? true : false;
                this.dph = this.itemEdit.dph ? this.itemEdit.dph : "23";
            } else {
                this.resetForm;
            }
        },
        methods: {
            saveSlug(value) {
                return value
                    .toString()
                    .toLowerCase()
                    .replace(/\s+/g, "-") // Replace spaces with -
                    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
                    .replace(/\-\-+/g, "-") // Replace multiple - with single -
                    .replace(/^-+/, "") // Trim - from start of text
                    .replace(/-+$/, "");
            },
            resetSlug() {
                this.isEditing = false;
                this.slug = this.saveSlug(this.nazov);
            },
            save() {
                /* CANT SAVE */
                if (this.nazov.length <= 0) {
                    this.error.nazov = true;
                    window.scrollTo(0, 0);
                } else {
                    this.error.nazov = false;
                }
                if (this.slug.length <= 0) {
                    this.error.slug = true;
                    window.scrollTo(0, 0);
                } else {
                    this.error.slug = false;
                }
                if (!this.error.nazov && !this.error.slug) {
                    /* CAN SAVE */
                    this.saved = true;
                    const fd = new FormData();
                    if (this.logo != null) {
                        fd.append("file", this.logo);
                    }
                    if (this.signature != null) {
                        fd.append("signature", this.signature);
                    }
                    var data = {
                        id: this.id,
                        user_id: this.user_id,
                        nazov: this.nazov,
                        osoba: this.osoba,
                        osoba_tel: this.osoba_tel,
                        osoba_email: this.osoba_email,
                        web: this.web,
                        nazov_spolocnosti: this.nazov_spolocnosti,
                        ico: this.ico,
                        dic: this.dic,
                        ic_dph: this.ic_dph,
                        ulica: this.ulica,
                        psc: this.psc,
                        mesto: this.mesto,
                        slug: this.slug,
                        fb: this.fb,
                        ig: this.ig,
                        yt: this.yt,
                        lin: this.lin,
                        dph: this.isDph ? this.dph : null,
                        main: this.itemEdit ? this.itemEdit.main : false
                    };
                    fd.append("data", JSON.stringify(data));
                    axios.post("/api/saveMojaFirma", fd).then((response) => {
                        this.saved = false;
                        this.resetForm;
                        response.data.main = this.itemEdit ? this.itemEdit.main : false;
                        this.$emit("save", response.data);
                    });
                }
            },
            resetForm() {
                this.error = false;
                this.nazov = "";
                this.osoba = "";
                this.osoba_tel = "";
                this.osoba_email = "";
                this.web = "";
                this.nazov_spolocnosti = "";
                this.ico = "";
                this.dic = "";
                this.ic_dph = "";
                this.ulica = "";
                this.psc = "";
                this.mesto = "";
                this.saved = false;
                this.slug = "";
                this.fb = "";
                this.ig = "";
                this.yt = "";
                this.lin = "";
                this.dph = "23";
            },
            checkDph(event){
                const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                if (!keysAllowed.includes(event.key) || this.dph.length > 2) {
                    event.preventDefault()
                }
            },
            psc_checker(event) {
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 4) {
                    this.psc = cleanedVal.substr(0, 4); // Limit length to 8 characters
                } else {
                    this.psc = cleanedVal;
                }
            },
            ico_checker(event) {
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 7) {
                    this.ico = cleanedVal.substr(0, 7); // Limit length to 8 characters
                } else {
                    this.ico = cleanedVal;
                }
            },
            dic_checker(event) {
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 9) {
                    this.dic = cleanedVal.substr(0, 9); // Limit length to 8 characters
                } else {
                    this.dic = cleanedVal;
                }
            },
            onlyNumber(event) {
                const keysAllowed = [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "+",
                    " ",
                ];
                if (!keysAllowed.includes(event.key) || (this.osoba_tel && this.osoba_tel.length > 15)) {
                    event.preventDefault();
                }
            },
            webInput() {
                var prefix = "https://";
                if (this.web != "") {
                    if (this.web.substring(0, prefix.length) != prefix) {
                        this.web = prefix + this.web;
                    }
                }
            },
            getSocialMedia(value) {
                this.fb = value.fb
                this.ig = value.ig
                this.yt = value.yt
                this.lin = value.lin
            },
        },
        watch: {
            slug: function() {
                let width = this.slug.length * 10;
                $('.odkaz input').css('width', width);
            },
            nazov: function() {
                if (this.error.nazov) {
                    if (this.nazov.length > 0) {
                        this.error.nazov = false;
                        this.slug = this.saveSlug(this.nazov);
                    }
                } else {
                    if (this.slug.length == 0) {
                        this.slug = this.saveSlug(this.nazov);
                    }
                    if (this.nazov != "") {
                        this.slug = this.saveSlug(this.nazov);
                    }
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    h1 {
        width: 100%;
        text-align: center;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
        margin-bottom: 30px;
    }

    .form {
        width: 480px;
        margin: 0 auto;
        padding: 24px;

        @media only screen and (max-width: 600px) {
            width: 95%;
            padding: 6px;
        }

        background: #ffffff;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;

        .one {
            width: 100%;
            margin: 0 auto;
            padding: 0;
            margin-bottom: 18px;

            .odkaz {
                width: 430px;
                margin: 0 auto;

                @media only screen and (max-width: 600px) {
                    width: 90%;
                }

                .odkaz_text {
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 150%;
                    color: #9598A7;

                }

                .bottom {
                    margin-top: 7px;
                    display: flex;
                    align-items: center;

                    .odkaz_web {
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 16px;
                        color: #9598A7;
                        ;
                    }

                    input {
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 16px;
                        color: #212541;
                        background: transparent;
                        border: none;
                        border-bottom: 0.15rem solid;
                        width: 150px;

                        &.error {
                            width: 150px !important;
                            border-color: red;
                        }
                    }

                    .resetslug {
                        margin-left: 5px;
                    }
                }


            }
        }

        .three {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @media only screen and (max-width: 600px) {
                display: block;
            }

            .form-floating.left {
                width: 167px;

                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
            }

            .form-floating.right {
                width: 246px;

                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
            }
        }

        .two {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @media only screen and (max-width: 600px) {
                display: block;
            }

            .form-floating {
                width: 210px;

                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
            }
        }

        h3 {
            width: auto;
            margin: 0 0 19px 0;
            font-family: "Roboto";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
            text-align: left;
        }

        h4 {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 21px;
            color: #9598a7;
            margin-bottom: 18px;
        }

        .form-floating {
            width: 100%;
            margin: 0 auto;

            input {
                display: flex !important;
                align-items: center !important;
                background: #ffffff;
                border: 1px solid #dde3e8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }

            label {
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598a7;
            }

            textarea {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
    .check{
        width: 430px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        .form-group{
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }
        label{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #C7D4EB;
            border-radius: 25px;
        }
        .toggle{
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #FFFFFF;
            border-radius: 3px;
            transition: all 0.2s ease;
            &:focus {
                outline: 0;
            }
            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }
            &:checked {
                border-color: #2ED8B6;
                background: #2ED8B6;
            }
            &:checked:after {
                transform: translatex(20px);
                
            }
        }
        .info{
            position: relative;
            height: 20px;
            margin-left: 10px;
            top: unset;
            right: unset;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img{
                    width: 80%;
                    height: 80%;
                }
            }
            .my_tooltip{
                bottom: 22px;
                right: -7px;
            }
        }
        .agree_tooltip{
            position: relative;
        }
        .my_tooltip{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #F3385A;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;
            &::after{
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
        .form-check{
            margin-bottom: 0;
            .form-check-input{
                width: 16px !important;
                height: 16px !important;
                border-radius: 2px !important;
                outline: none !important;
                box-shadow: none !important;
            }
            .form-check-input:checked{
                background-color: #212541 !important;
                border: 1px solid #212541 !important;
            }
            label{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;

                color: #212541;
            }
        }
        .text{
            margin-left: 35px;
            span{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
            input{
                text-align: center;
                width: 30px;
                border: none;
                background: transparent;
                border-bottom: 2px solid #212541;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
    .ulozit {
        width: 480px;
        height: 55px;
        margin: 0 auto;
        margin-top: 25px;
        background: #2ed8b6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        transition: 0.5s all;

        &:hover {
            background: #23caa9;
        }
    }

    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }

        100% {
            transform: scale(1);
        }
    }

    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(0);
        }
    }

    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }

        100% {
            transform: translate(24px, 0);
        }
    }

    .info {
        position: absolute;
        height: 20px;
        top: 16px;
        right: 11px;

        .info_icon {
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            float: right;

            img {
                width: 80%;
                height: 80%;
            }
        }

        .my_tooltip {
            bottom: 22px;
            right: -7px;
        }

        &:hover {
            .my_tooltip {
                opacity: 1;
            }
        }
    }

    .agree_tooltip {
        position: relative;
    }

    .my_tooltip {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 300px;
        background: #f3385a;
        box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: unset;
        right: 15px;
        z-index: 10000;
        transition: opacity 0.5s ease-in-out;

        &::after {
            content: "";
            width: 15px;
            height: 15px;
            background: #f3385a;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }
</style>
</style>
